import { Inject, Injectable } from '@angular/core';
import {
	CanActivate,
	Router,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import {
	SanitizerService,
	sanitizerServiceToken
} from 'go-modules/services/xss/sanitizer.service';
import { NgxAuthService } from '@go-modules/services/auth/auth.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {
	constructor (
		private ngxAuthService: NgxAuthService,
		private router: Router,
		@Inject(sanitizerServiceToken) private sanitizerService: SanitizerService,
		@Inject('Window') private window: Window
	) {}

	public canActivate (
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (this.ngxAuthService.isActive()) {
			// Check for redirect parameter
			const redirect = route.queryParams.redirect;
			if (redirect && this.sanitizerService.isValidRedirectUrl(redirect)) {
				this.window.location.href = redirect;
				return false;
			}
			return true;
		} else {
			// Redirect to login with current URL as redirect parameter
			const redirectUrl = state.url;
			return this.router.createUrlTree(['/dashboard/auth/login'], {
				queryParams: { redirect: redirectUrl }
			});
		}
	}
}
